
webpack.register(
    'modules/advert/live-video-advert/live-video-advert',
    function() {
        return import('modules/advert/live-video-advert/live-video-advert');
    },
    true
);